'use strict';exports.__esModule = true;var _memorystorage = require('memorystorage');var _memorystorage2 = _interopRequireDefault(_memorystorage);
var _checkers = require('./checkers');
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var setupStorage = function setupStorage() {
  _constants.storage.value = (0, _checkers.isLocalStorageAvailable)() ? global.localStorage : new _memorystorage2.default();
};exports.default =

setupStorage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/setupStorage.js
// module id = 3167
// module chunks = 0